// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as jsxRuntime from "react/jsx-runtime";
export const P3 = "_screen_1tiih_1";
export const eS = "_center_1tiih_2";
export const tS = "_symbol_1tiih_3";
export const aS = "_spinner_1tiih_6";
export const Ki = {
  screen: P3,
  center: eS,
  symbol: tS,
  spinner: aS
};
export function StartupScreen({
  phase: u
}) {
  return jsxRuntime.jsx("div", {
    className: Ki.screen,
    role: "status",
    "aria-live": "polite",
    children: jsxRuntime.jsxs("div", {
      className: Ki.center,
      children: [jsxRuntime.jsx("span", {
        className: Ki.symbol,
        "aria-hidden": "true",
        children: "✦"
      }), jsxRuntime.jsx("h1", {
        children: "MetaCard"
      }), jsxRuntime.jsx("p", {
        children: "АНИМЕ-КАРТЫ В TELEGRAM"
      }), jsxRuntime.jsx("span", {
        className: Ki.spinner,
        "aria-hidden": "true"
      }), jsxRuntime.jsx("small", {
        children: u === "cards" ? "Подготавливаем карты" : "Загружаем вселенные"
      })]
    })
  });
}
